import { DateRange } from '@shared/models/common.models';
import { MonitoringReportResponseDTO } from '@generated-apis/model/monitoringReportResponseDTO';

export class TriggerReportGeneration {
  static readonly type = '[ReportGeneration] Trigger report generation';

  constructor(
    public geaPUID: string,
    public dateRange: DateRange
  ) {}
}

export class GenerateReport {
  static readonly type = '[ReportGeneration] Get Generated Report';

  constructor(
    public geaPUID?: string,
    public timezone?: string,
    public startDate?: string,
    public endDate?: string
  ) {}
}

export class InitiatePolling {
  static readonly type = '[ReportGeneration] Initiate polling';

  constructor(
    public geaPUID: string,
    public pollingInterval: number
  ) {}
}

export class GetReportGenerationStatus {
  static readonly type = '[ReportGeneration] Get report generation status';

  constructor(public geaPUID: string) {}
}

export class ResetReportGeneration {
  static readonly type = '[ReportGeneration] Reset report generation';
}

export class MonitoringReportDataLoaded {
  static readonly type = '[ReportGeneration] Report General Data Loaded';

  constructor(public report: MonitoringReportResponseDTO) {}
}
